import type { Contact } from '@/Api/studioServerTypes';

export function buildContactPutPayload(
  contact: Contact,
  contactEdited: Partial<Contact>,
): Contact {
  return {
    AccountNumber: contact.AccountNumber,
    ContactIdentifier: contact.ContactIdentifier,
    ContactNumber: contact.ContactNumber,
    StripeCustomerId: contact.StripeCustomerId,

    FirstName: contactEdited.FirstName ?? contact.FirstName,
    LastName: contactEdited.LastName ?? contact.LastName,
    CompanyName: contact.CompanyName,
    Title: contact.Title,
    Country: contact.Country,

    Address1: contact.Address1,
    Address2: contact.Address2,
    City: contactEdited.City ?? contact.City,
    StateProvince: contact.StateProvince,
    PostalCode: contact.PostalCode,
    InternationalFirstName: contact.InternationalFirstName,
    InternationalLastName: contact.InternationalLastName,
    InternationalCompanyName: contact.InternationalCompanyName,
    InternationalTitle: contact.InternationalTitle,
    InternationalCountry: contact.InternationalCountry,
    InternationalAddress1: contact.InternationalAddress1,
    InternationalAddress2: contact.InternationalAddress2,
    InternationalCity: contact.InternationalCity,
    InternationalStateProvince: contact.InternationalStateProvince,
    InternationalPostalCode: contact.InternationalPostalCode,

    ClientIdentifier: contact.ClientIdentifier ?? null,
    OwnedByClientIdentifier: contact.OwnedByClientIdentifier ?? null,

    WorkRole: contact.WorkRole,
    WorkTelephone: contact.WorkTelephone,
    MobileTelephone: contactEdited.MobileTelephone ?? contact.MobileTelephone,
    HomeTelephone: contact.HomeTelephone,
    FaxTelephone: contact.FaxTelephone,
    Email: contactEdited.Email ?? contact.Email,
    AlternateEmail: contact.AlternateEmail,

    LoginDisabled: !!contact.LoginDisabled,
    WebSiteUrl: contact.WebSiteUrl,

    ContactType: contact.ContactType ?? null,
    Notes: contact.Notes,

    DoNotUse: !!contact.DoNotUse,

    AddedBy: contact.AddedBy,
    DateAdded: contact.DateAdded,
    ModifiedBy: contact.ModifiedBy,
    DateModified: contact.DateModified,

    ImportIdentifier: contact.ImportIdentifier,
    IsPersonal: !!contact.IsPersonal,
    IsStaff: !!contact.IsStaff,
    IsVendor: !!contact.IsVendor,

    Telephone1Label: contact.Telephone1Label,
    Telephone1: contact.Telephone1,
    Telephone2Label: contact.Telephone2Label,
    Telephone2: contact.Telephone2,
    Telephone3Label: contact.Telephone3Label,
    Telephone3: contact.Telephone3,
    Telephone4Label: contact.Telephone4Label,
    Telephone4: contact.Telephone4,
    Telephone5Label: contact.Telephone5Label,
    Telephone5: contact.Telephone5,

    GoogleRefreshToken: contact.GoogleRefreshToken,
    GoogleTaskListId: contact.GoogleTaskListId,
    InstagramUrl: contactEdited.InstagramUrl ?? contact.InstagramUrl,
  };
}
